import { render, staticRenderFns } from "./confirm-modal.vue?vue&type=template&id=8b3c5934&"
import script from "./confirm-modal.vue?vue&type=script&lang=js&"
export * from "./confirm-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports